import React, { SFC } from 'react';

import {
  Container,
  ContainerProps,
  Typography,
  WithStyles,
  createStyles,
  cx,
  withStyles,
} from '@robotsnacks/ui';

const styles = createStyles<'root'>(() => ({
  root: {
    boxSizing: 'border-box',
    position: 'relative',
  },
}));

export type RichTextBlockWrapperProps = ContainerProps;

type Props = WithStyles<RichTextBlockWrapperProps, typeof styles>;

const EventBlockWrapper: SFC<Props> = ({
  children,
  classes,
  className,
  ...rest
}) => (
  <Container className={cx(classes.root)} type="prose" {...rest}>
    {children}
  </Container>
);

EventBlockWrapper.displayName = 'EventBlockWrapper';

export default withStyles(styles)(EventBlockWrapper);
